import { render, staticRenderFns } from "./AdminAddAdsDialog.vue?vue&type=template&id=91987e24"
import script from "./AdminAddAdsDialog.vue?vue&type=script&lang=js"
export * from "./AdminAddAdsDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminAddAdsDialog.vue?vue&type=style&index=0&id=91987e24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports